<script lang="ts">
  import { DEFAULT_IMAGES } from '@/comps-sdk/constants';
  import { type ICommon } from '@/comps-sdk/interface';

  export let userInfo:
    | (ICommon.UserInfo & {
        frameAvatar?: string;
      })
    | null = {
      headImgUrl: DEFAULT_IMAGES.avatar,
      type: '',
      nickname: '',
      frameAvatar: '',
    };

  let loginTypeImg = '';
  let { avatar } = DEFAULT_IMAGES;
  let frameAvatar = '';
  let nickname = '腾讯网友';

  $: {
    if (userInfo) {
      const { type, headImgUrl } = userInfo;
      if (type === 'qq') {
        loginTypeImg = DEFAULT_IMAGES.qq;
      } else if (type === 'wx') {
        loginTypeImg = DEFAULT_IMAGES.wx;
      }
      avatar = headImgUrl || DEFAULT_IMAGES.avatar;
      frameAvatar = userInfo.frameAvatar || '';
      nickname = userInfo.nickname || '腾讯网友';
    }
  }
</script>

<div class="user-info-wrapper">
  <div class="avatar-wrapper">
    {#if frameAvatar}
      <img class="frame-avatar" src={frameAvatar} alt="" />
    {/if}
    <img class="user-avatar" src={avatar} alt="" />
    <img class="account-type" src={loginTypeImg} alt="" />
  </div>
  <div class="user-name">
    {nickname}
  </div>
</div>

<style lang="scss">
  .user-info-wrapper {
    text-align: center;
    margin-bottom: 20px;
    .avatar-wrapper {
      height: 56px;
      width: 65px;
      margin: auto;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .frame-avatar {
        position: absolute;
        height: 100%;
        width: 100%;
      }
      .user-avatar {
        height: 42px;
        width: 42px;
        border-radius: 100%;
      }
      .account-type {
        position: absolute;
        bottom: 6px;
        right: 10px;
        height: 12px;
        width: 12px;
      }
    }
    .user-name {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 15px;
      color: #191919;
      margin-bottom: 4px;
    }
  }
</style>
